import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    dialogTitle: {
        display: 'flex',
        justifyContent: 'center',
        fontSize: '1.5rem',
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
    },
    textField: {
        marginTop: '20px',
        maxWidth: '250px',
    },
    dialogActions: {
        display: 'flex',
        justifyContent: 'flex-start',
        padding: '20px',
    },
    save: {
        height: '36px',
        width: '102px',
    },
    tagContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    checkboxContainer: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: '10px',
    },
    uploadContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: '20px',
    },
    uploadButton: {
        padding: '20px',
        borderStyle: 'dashed',
        borderColor: 'blue',
        borderWidth: '2px',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        display: 'flex',
        flex: 1,
    },
    uploadIcon: {
        marginRight: '5px',
        fontSize: '30px',
        color: 'blue',
        marginBottom: '5px',
    },
    chipContainer: {
        marginLeft: '20px',
        marginTop: '20px',
    },
    chip: {
        marginLeft: '5px',
        marginTop: '5px',
    },
    designChip: {
        marginTop: '20px',
    },
}));
